import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiMenuWrapper = styled.div`
  padding-left: 0px;
  .no-padding {
    display: block;
    padding: 0px;
  }
  .MuiPaper-rounded {
    border-radius: 8px;
    box-shadow: 0px 2px 12px 0px ${COLORS.shadow_black};
  }
  .item-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 14px 25px 14px 20px;
  }

  .item-text {
    padding-right: 20px;
    color: ${COLORS.primary_light_blue};
    white-space: pre;
  }
`;
